import { useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';

export interface AddressSelectionModalProps {
  open: boolean;
  addresses: string[];
  theme?: string;
  onSelect: (index: number) => void;
  onCancel: () => void;
}

export function AddressSelectionModal({
  open,
  addresses = [],
  theme,
  onSelect,
  onCancel,
}: AddressSelectionModalProps) {
  const handleSelect = useCallback(
    (index: number) => {
      onSelect(index);
    },
    [onSelect]
  );

  return (
    <BaseFormModal
      open={open}
      title="Multiple Address Results"
      theme={theme}
      showSave={false}
      cancelText="Cancel"
      onCancel={onCancel}
    >
      <h4>There are multiple address matches, please select one.</h4>
      <ul className="list-group">
        {addresses.map((address, index) => (
          <li key={index} className="list-group-item">
            <button
              type="button"
              className="btn btn-link"
              style={{ width: '95%', textAlign: 'left' }}
              title={address}
              onClick={() => handleSelect(index)}
            >
              {address}
            </button>
          </li>
        ))}
      </ul>
    </BaseFormModal>
  );
}

(window as any).AddressSelectionModalReact = AddressSelectionModal;
